import {
  Box,
  Button,
  Divider,
  Image,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useState } from "react";
import type { Session } from "../lib/api";
import { BrandWordmark } from "../components/BrandWordmark";

interface Props {
  loading: boolean;
  onConnectKukai: () => Promise<Session>;
  onConnectWallet: () => Promise<Session>;
}

export function ConnectScreen({
  loading,
  onConnectKukai,
  onConnectWallet,
}: Props) {
  const [error, setError] = useState<string | null>(null);

  const handleWallet = async () => {
    setError(null);
    try {
      await onConnectWallet();
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : "Connection failed");
    }
  };

  const handleKukai = async () => {
    setError(null);
    try {
      await onConnectKukai();
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : "Connection failed");
    }
  };

  return (
    <Box
      h="100vh"
      style={{
        display: "grid",
        placeItems: "center",
        background: "linear-gradient(180deg, #f0f2f5 0%, #fafbfc 100%)",
        padding: 20,
      }}
    >
      <Box
        w={420}
        p="xl"
        style={{
          background: "#ffffff",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.10)",
          border: "1px solid rgba(0, 0, 0, 0.06)",
          borderRadius: 16,
        }}
      >
        <Stack align="center" gap="md">
          <Image
            src="/assets/drobbit.gif"
            alt="Drobbit"
            w={88}
            h={88}
            radius="md"
          />
          <Title
            order={1}
            fz={40}
            ta="center"
            c="dark"
            lts="0.04em"
            ff="'Bebas Neue', sans-serif"
          >
            <BrandWordmark alphaFontSizeEm={0.38} />
          </Title>
          <Text size="sm" c="gray.6" ta="center">
            Enter the world of the Drobbits
          </Text>
        </Stack>

        <Stack gap="sm" mt="xl">
          <Button
            fullWidth
            size="lg"
            loading={loading}
            onClick={() => void handleKukai()}
          >
            Social Login
          </Button>

          <Divider
            label="or"
            labelPosition="center"
            color="dark.4"
            styles={{ label: { color: "var(--mantine-color-gray-6)" } }}
          />

          <Button
            fullWidth
            size="lg"
            variant="light"
            loading={loading}
            onClick={() => void handleWallet()}
          >
            Existing Tezos Wallet
          </Button>

          {error && (
            <Box
              p="xs"
              style={{
                borderRadius: 8,
                backgroundColor: "rgba(224, 49, 49, 0.08)",
                border: "1px solid rgba(224, 49, 49, 0.2)",
              }}
            >
              <Text size="xs" c="red.7">
                {error}
              </Text>
            </Box>
          )}
        </Stack>
      </Box>
    </Box>
  );
}
